interface SortableAllocation {
  investorLabel?: string;
  investorName?: string;
  isNewTransferee?: boolean;
}

export const sortAllocations = <T extends SortableAllocation>(
  allocations: Array<T>,
): Array<T> => {
  return [...allocations].sort((a, b) => {
    // New transferee commitments go to the bottom
    const aIsTransferee = a.isNewTransferee === true;
    const bIsTransferee = b.isNewTransferee === true;
    if (aIsTransferee !== bIsTransferee) {
      return aIsTransferee ? 1 : -1;
    }
    // Within each group, sort alphabetically by investor name
    const nameA = a.investorLabel ?? a.investorName ?? '';
    const nameB = b.investorLabel ?? b.investorName ?? '';
    return nameA.localeCompare(nameB);
  });
};
